// Module
var code = "<script>let $ctrl</script> <button class=\"button button--edit\" type=\"button\" ng-click=\"$ctrl.download()\" name=\"button-download\" title=\"{{ '2f2fd624-c045-481d-b499-2b4e7af38324' | translate }}\"> <fa-icon class=\"button__icon\" icon=\"download\"></fa-icon> </button> ";
// Exports
module.exports = code;